import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import CircularProgress from '@material-ui/core/CircularProgress';
import SettingsButton from '../Settings/SettingsButton/SettingsButton';
import api from 'api';
import classes from './StripePaymentForm.module.scss';

const StripePaymentForm = ({ onCancel, onSuccess, family, paymentAmount, translate, currency = 'USD' }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);
  const familyId = family._id;
  const email = family.email;
  const customerId = family.stripeCustomerId; 
  let paymentMethodId = family.paymentMethodId;
  let paymentMethodCard = family.paymentMethodCard;
  const [method, setMethod] = useState(paymentMethodId);
  const [card, setCard] = useState(paymentMethodCard);

  const requestPaymentMethod = async () => {
    setProcessing(true);

    if (!paymentMethodId) {
      const { error: methodError, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement),
      });

      if (methodError) {
        setProcessing(false);
        return;
      }

      console.log('StripePaymentForm paymentMethod: ', paymentMethod);
      paymentMethodId = paymentMethod.id;
      paymentMethodCard = `${paymentMethod.card.brand} ... ${paymentMethod.card.last4}`;
    }

    let res;

    console.log('[StripePaymentForm][paymentMethod]', {
      familyId,
      paymentAmount,
      currency,
      hasCustomerId: Boolean(customerId),
      hasSavedPaymentMethod: Boolean(paymentMethodId),
    });

    if (!customerId) {
      res = await api.stripe.createStripePaymentIntent(
        paymentAmount * 100, 
        familyId, 
        paymentMethodId, 
        paymentMethodCard,
        email,
        '',
        false,
        currency
        );     
    }    
    else {
      res = await api.stripe.createStripePaymentIntent(
        paymentAmount * 100, 
        familyId, 
        paymentMethodId, 
        paymentMethodCard,
        email,
        customerId,
        true,
        currency
        );
    }

    console.log('[StripePaymentForm][paymentResult]', res);
    const { paymentIntent, error } = res;

    if (error) {
      setProcessing(false);
      onSuccess({
        message: 'Card Error! Try other card!',
        status: 'failed'
      })
    } else if (paymentIntent.status === 'succeeded') {     
      setProcessing(false);
      onSuccess({
        message: translate(3089, 'Payment successful'),
        status: 'succeeded'
      });
    }
  };

  const onChangeCard = async () => {
    setProcessing(true);
    await api.family.removePaymentMethod(familyId);
    setMethod('');
    setCard('');
    console.log('onChangeCard');
    setProcessing(false);
  }

  return (
    <form>
      {!method &&
        <CardElement />
      }
      {card &&
      <div className={classes.cardLabelWrapper}>
        <label className={classes.cardLabel}>{card}</label>
        <SettingsButton type="button" onClick={onChangeCard}>
            Change Card
        </SettingsButton>
      </div>
      }
      
      {processing && (
        <div className={classes.spinnerWrapper}>
          <CircularProgress />
        </div>
      )}

      <div className={classes.footer}>
        {onCancel && (
          <SettingsButton onClick={onCancel} color="secondary">
            Cancel
          </SettingsButton>
        )}

        <SettingsButton
          onClick={requestPaymentMethod}
          disabled={!stripe || processing}
          type="submit"
        >
          Submit
        </SettingsButton>
      </div>    
    </form>
  );
};

StripePaymentForm.propTypes = {
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  currency: PropTypes.string,
};

export default StripePaymentForm;
